













import { Component, Vue } from 'vue-property-decorator';
import LoadingOverlay from '@/components/molecules/LoadingOverlay.vue';
import Dialog from '@/components/molecules/Dialog.vue';
import DialogPlugin, { DialogInstance } from '@/plugins/DialogPlugin';
import ExternalPageViewer from '@/views/ExternalPageViewer.vue';
import ExternalPagePlugin, {
  ExternalPageInstance,
} from '@/plugins/ExternalPagePlugin';

@Component({
  components: {
    LoadingOverlay,
    Dialog,
    ExternalPageViewer,
  },
})
export default class App extends Vue {
  private dialogs: DialogInstance[] = [];

  private externalPages: ExternalPageInstance[] = [];

  private get showLoadingOverlay(): boolean | string {
    return this.$store.state.showLoadingOverlay;
  }

  private beforeMount() {
    this.dialogs = DialogPlugin.dialogs;
    if (DialogPlugin.EventBus) {
      DialogPlugin.EventBus.$on('dialogs', (dialogs: DialogInstance[]) => {
        this.dialogs = dialogs;
      });
    }
    this.externalPages = ExternalPagePlugin.externalPages;
    if (ExternalPagePlugin.EventBus) {
      ExternalPagePlugin.EventBus.$on(
        'externalPages',
        (externalPages: ExternalPageInstance[]) => {
          this.externalPages = externalPages;
        }
      );
    }
  }
}
